import React from 'react';

import block from 'propmods';

import './Statuses.scss';

interface StatusProps {
    color: Color;
    message: string;
}

export type Color = 'green' | 'yellow' | 'red';

const b = block('Status');

export default function Status({ color, message }: StatusProps) {
    return (
        <div {...b()}>
            <div {...b('indicator', { color })} />
            <div {...b('message')}>{message}</div>
        </div>
    );
}
